import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { forkJoin } from 'rxjs';
import { Alert, AlertService } from '@michelin/theme';
import { StateDto } from 'src/app/shared/models/location/state-dto';
import { ProductLineDto } from 'src/app/shared/models/product-line/product-line-dto';
import { AutomakerFormComponent } from '../components/automaker-form/automaker-form.component';
import { AutomakerService } from 'src/app/shared/services/automaker/automaker.service';
import { LocationService } from 'src/app/shared/services/location/location.service';
import { ProductLineService } from 'src/app/shared/services/product-line/product-line.service';

@Component({
    selector: 'app-create-automaker',
    templateUrl: './create-automaker.component.html',
    standalone: false
})
export class CreateAutomakerComponent implements OnInit {
  loading: boolean = false;

  data = {
    states: [] as StateDto[],
    productLines: [] as ProductLineDto[]
  };

  @ViewChild(AutomakerFormComponent) automakerForm: AutomakerFormComponent;

  constructor(
    private readonly automakerService: AutomakerService,
    private readonly locationService: LocationService,
    private readonly productLineService: ProductLineService,
    private readonly alertService: AlertService,
    private readonly router: Router
  ) {}

  ngOnInit() {
    this.loading = true;

    forkJoin({
      states: this.locationService.findAllStates(),
      productLines: this.productLineService.findAll()
    })
      .subscribe({
        next: (result) => (this.data = result),
        error: () =>
          this.alertService.showAlert({
            type: 'critical',
            content: 'Ocorreu um erro ao recuperar as informações'
          } as Alert)
      })
      .add(() => (this.loading = false));
  }

  submitForm() {
    this.loading = true;
    this.automakerService
      .create(this.automakerForm.formValues as any)
      .subscribe({
        next: () =>
          this.router.navigate(['/automakers']).then(() =>
            this.alertService.showAlert({
              type: 'success',
              content: 'Montadora cadastrada com sucesso'
            } as Alert)
          ),
        error: () =>
          this.alertService.showAlert({
            type: 'critical',
            content: 'Ocorreu um erro ao cadastrar a Montadora'
          } as Alert)
      })
      .add(() => (this.loading = false));
  }
}
